import React from 'react';

import AnimatedFooter from './AnimatedFooter';
import Aside from './Aside';
import Collections from './Collections';
import Container from 'app/shared/core/Container';
import Footer from 'app/shared/modules/Footer';
import Hero from './Hero';
import TopCities from 'app/shared/modules/frontpage/TopCities';
import { homeHubCSS, homeHubSectionsCSS } from 'app/shared/modules/HomeHub/styles';
import './style.scss';

const renderSnowflakes = () => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Month integer is offset by -1
  const currentDay = currentDate.getDate();

  if (currentMonth === 12 && currentDay >= 20 && currentDay <= 26) {
    return (
      <div className="snowflakes" aria-hidden="true">
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
        <div className="snowflake">❅</div>
        <div className="snowflake">❆</div>
      </div>
    );
  }

  return null;
};

function HomeHub() {
  return (
    <React.Fragment>
      {renderSnowflakes()}
      <Container size="lg" className={homeHubCSS}>
        <Hero />
        <div className={homeHubSectionsCSS}>
          <Collections />
          <Aside />
        </div>
      </Container>
      <AnimatedFooter />
      <TopCities />
      <Footer crossbrand />
    </React.Fragment>
  );
}

export default HomeHub;
